/*
 * shopit-api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.41
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {CartValidationRequestCart} from './CartValidationRequestCart';
import {User} from './User';

/**
 * The CartValidationRequest model module.
 * @module model/CartValidationRequest
 * @version v1
 */
export class CartValidationRequest {
  /**
   * Constructs a new <code>CartValidationRequest</code>.
   * @alias module:model/CartValidationRequest
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>CartValidationRequest</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/CartValidationRequest} obj Optional instance to populate.
   * @return {module:model/CartValidationRequest} The populated <code>CartValidationRequest</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new CartValidationRequest();
      if (data.hasOwnProperty('cart'))
        obj.cart = CartValidationRequestCart.constructFromObject(data['cart']);
      if (data.hasOwnProperty('user'))
        obj.user = User.constructFromObject(data['user']);
    }
    return obj;
  }
}

/**
 * @member {module:model/CartValidationRequestCart} cart
 */
CartValidationRequest.prototype.cart = undefined;

/**
 * @member {module:model/User} user
 */
CartValidationRequest.prototype.user = undefined;

